import styled from "styled-components";

export const AboutWrapper = styled.div`
    min-height: 100vh;
    width: 100%;
`;